module.exports = "/_next/static/images/59599a9b4936cdf9eefd007e19657d27-challenge-the-system-lg@3x.jpg";